/**
 * walletUtils — W1.5
 *
 * Hilfsfunktionen fuer Wallet-Feature.
 */
import i18next from 'i18next'

/**
 * Leitet aus einer Solana-Adresse einen CSS-Gradient ab (HSL-Hash).
 * Identisches Pattern wie Hotspot-Avatar (tone-N), aber als echter Gradient.
 */
export function hashToGradient(address: string): string {
  let hash = 0
  for (let i = 0; i < address.length; i++) {
    hash = address.charCodeAt(i) + ((hash << 5) - hash)
  }
  const h1 = Math.abs(hash) % 360
  const h2 = (h1 + 120) % 360
  return `linear-gradient(135deg, hsl(${h1}, 70%, 55%), hsl(${h2}, 70%, 45%))`
}

/**
 * Kuerzt eine Solana-Adresse auf erste 4 + letzte 4 Zeichen.
 * Bsp: "8xKpABCDEFGHvW3Z" -> "8xKp...vW3Z"
 */
export function truncateAddress(addr: string): string {
  if (addr.length <= 10) return addr
  return `${addr.slice(0, 4)}...${addr.slice(-4)}`
}

/**
 * Wandelt Lamports in SOL um (1 SOL = 1e9 Lamports).
 * Gibt einen formatierten String mit 4 Dezimalstellen zurueck.
 */
export function formatLamports(lamports: number): string {
  return (lamports / 1_000_000_000).toFixed(4)
}

/**
 * Token-spezifische Farben aus Design-Tokens (X0.5).
 */
export const TOKEN_COLORS: Record<string, string> = {
  hnt:    'var(--token-hnt, #474DFF)',
  iot:    'var(--token-iot, #21C5A0)',
  mobile: 'var(--token-mobile, #009FF9)',
  dc:     'var(--token-dc, #9B5DE5)',
  sol:    'var(--token-sol, #9945FF)',
}

/**
 * Solana-Explorer-Link fuer eine Transaktion.
 */
export function explorerUrl(signature: string): string {
  return `https://solscan.io/tx/${signature}`
}

/**
 * Relativer Zeitstempel (z.B. "vor 2 Stunden" / "2 hours ago" je nach i18n.language).
 * Non-React-Utility → direkter i18next.t()-Aufruf (kein useTranslation, s. Fix-Muster i18n100-1).
 */
export function relativeTime(isoDate: string): string {
  const diff = Date.now() - new Date(isoDate).getTime()
  const minutes = Math.floor(diff / 60_000)
  if (minutes < 1) return i18next.t('wallets:relativeTime.justNow')
  if (minutes < 60) return i18next.t('wallets:relativeTime.minutes', { count: minutes })
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return i18next.t('wallets:relativeTime.hours', { count: hours })
  const days = Math.floor(hours / 24)
  return i18next.t('wallets:relativeTime.days', { count: days })
}
